import React from "react";

// Authentication is still pending. Announce it without painting a substitute
// page between the browser's initial document and the requested destination.
export default function AppLoadingShell() {
  return <div className="toto-loading-shell" role="status" aria-live="polite" aria-busy="true">Loading…</div>;
}
